
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "SOTIM",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/SOTIM.vue